export default __webpack_public_path__ + "static/media/NS.fb39820f.svg";